<template>
  <div
    class="relative rounded-xl bg-white-100 p-4 shadow-drop-2"
    @click="emit('click:presentation')"
  >
    <div
      v-if="data.path"
      class="absolute bottom-4 right-4 z-10 size-7 cursor-pointer p-1 transition-transform duration-300 ease-in-out hover:scale-110"
      @click.stop="handlePresentationLoad(data.path)"
    >
      <SvgIcon name="download" />
    </div>
    <div class="group relative flex size-full cursor-pointer flex-col">
      <MainPageCardsReworkedCommonCardImageBlock
        :data
        disable-label
        :aspect="aspect"
        class="size-full"
      >
        <div
          class="absolute left-1/2 top-1/2 z-40 -translate-x-1/2 -translate-y-1/2"
        >
          <SvgIcon name="presentation-icon" class="size-8 text-white-100" />
        </div>
      </MainPageCardsReworkedCommonCardImageBlock>
      <div class="flex flex-1 flex-col">
        <div
          v-if="categoryTitle"
          class="mt-2 w-fit rounded-md bg-[#A100090F] px-2 py-1.5 text-[12px] leading-[14px] text-specialprojectsection"
        >
          {{ scoolClass.title }} | {{ categoryTitle }}
        </div>
        <div class="mt-2 flex pr-7">
          <MainPageCardsReworkedTeacherContentSrcIcon
            :link="data.entity_source?.url ?? null"
            class="mr-2 mt-[3px] size-4"
          />
          <div
            class="text- break-words font-roboto text-[16px] font-medium leading-[22px]"
          >
            {{ data.title }}
          </div>
        </div>
        <div v-if="data.authors?.length" class="flex flex-wrap">
          <div
            v-for="(author, index) in data.authors"
            :key="author.id"
            class="mt-2 flex flex-wrap items-center font-roboto text-[14px] leading-[18px] text-[#949494]"
          >
            {{ author.fullname
            }}<template v-if="index !== data.authors.length - 1"
              >,&nbsp;</template
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { downloadPresentation } from '~/composables/Others/usePresentation';

const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
  categoryTitle: {
    type: String,
    default: '',
  },
  scoolClass: {
    type: Object,
    default: () => ({}),
  },
  shelfName: {
    type: String,
    default: '',
  },
  paragraphNumber: {
    type: String,
    default: '',
  },
  aspect: {
    type: Object,
    default: () => ({
      w: 16,
      h: 9,
    }),
  },
});

const emit = defineEmits(['click:presentation']);

const handlePresentationLoad = (path) => {
  downloadPresentation(path, {
    shelfName: props.shelfName,
    className: props.scoolClass?.title,
    materialTitle: props.data?.title,
    paragraphNumber: props.paragraphNumber,
  });
};
</script>

<style lang="scss">
.animated-announce-hovered {
  opacity: 0;
  height: 0;
  transform: translateY(100%);
  transition: 500ms;
  transition-delay: 150ms;
}
.animated-announce:hover .animated-announce-hovered {
  transform: translateY(0%);
  opacity: 1;
  height: initial;
}
</style>
